import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthCedentialsService } from './auth-credentials.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private authCedentialsService: AuthCedentialsService
) {}

  canActivate( route: ActivatedRouteSnapshot, 
      state: RouterStateSnapshot): Observable<boolean> | boolean {     
        const hastoken =  this.authCedentialsService.hasToken()   
      if(hastoken){
        return true;
      }else{
          this.router.navigate(['/login']);
      }
  }
}